import React from 'react'
import { Col, Collapse, Popconfirm, Row, Tooltip } from 'antd'
import SelectedPurposeTable from 'Components/SelectedPurposeTable'
import { purposeState, userType } from 'Common/constants'
import { purposePermission } from 'Common/utils'
import * as _ from 'lodash'
import { MarginLeftButton } from '../../common/styled'
import api from '../../common/api'
import HandleProposalModal from '../HandleProposalModal'
import HandleProposalShipmentModal from '../HandleProposalShipment'
import ExcelComponent from '../ExcelComponent'


const Panel = Collapse.Panel
class Purpose extends React.Component {
    state = {
        userType,
        loading: false,
        isModalOpen: false,
        isModalShipmentOpen: false
    }
    _exporter;

    export = () => {
        this._exporter.save();
    }

    onProposalUpdate(value, proposalId, save = false) {
        const newData = this.props.proposals.slice();
        const index = newData.findIndex(item => proposalId === item.id)
        const item = newData[index]
        const newItem = {
            ...item,
            ...value
        };

        newData.splice(index, 1, newItem);
        if (save) {
            this.setState({loading: true});

            api.purposes.edit(newItem).then(res => {
                this.setState({loading: false});
            }).catch(err => {
                console.error(err);
                this.setState({loading: false});
            });
        }
        this.props.onChangeCallback(newData, save)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.selectedAgreement !== this.props.selectedAgreement) {
            this.forceUpdate();
        }
    }

    canShipProducts(proposal) {
        return !_.isEmpty(_.trim(proposal.ddt)) && !_.isEmpty(_.trim(proposal.bds)) && !_.isNil(proposal.packages) && !_.isNil(proposal.pallet);
    }

    renderPurposeTable(purpose) {
        const purposeObj = purposePermission(purpose.state, this.props.user);
        const {selectedAgreement, user} = this.props;

        if (purposeObj.canView) {
            return (
                <React.Fragment>
                    <Row gutter={16} style={{marginBottom: 16}}>
                        {purpose.trash === true && <Col span={8}><span style={{color: '#cc3333'}}><strong>Reso per distruzione</strong></span></Col>}
                        {!_.isNil(purpose.storeManager) && <Col
                            span={8}><span><strong>Capo Settore:</strong> {purpose.storeManagerFirstName + ' ' + purpose.storeManagerLastName}</span></Col>}
                        {!_.isNil(purpose.supplyChain) && <Col
                            span={8}><span><strong>Supply Chain:</strong> {purpose.supplyChainFirstName + ' ' + purpose.supplyChainLastName}</span></Col>}
                    </Row>
                    {[purposeState[0].key, purposeState[1].key, purposeState[2].key, purposeState[6].key, purposeState[7].key, purposeState[8].key].indexOf(purpose.state) === -1 &&
                    <div style={{marginBottom: 16}}>
                        <Row gutter={16} style={{marginBottom: 16}}>
                            <Col span={6}><span><strong>Numero DDT:</strong> {purpose.ddt}</span></Col>
                            <Col span={6}><span><strong>Numero BDS:</strong> {purpose.bds}</span></Col>
                            <Col span={6}><span><strong>Colli:</strong> {purpose.packages}</span></Col>
                            <Col span={6}><span><strong>Pallet:</strong> {purpose.pallet}</span></Col>
                        </Row>
                    </div>}
                    <SelectedPurposeTable onProposalUpdate={value => this.onProposalUpdate(value, purpose.id)}
                                          tableRules={purposeObj} data={purpose} selectedAgreement={selectedAgreement}
                                          user={this.props.user} loading={this.state.loading}/>
                    <div style={{marginLeft: '-1rem'}}>
                        {this.canSave(purpose) ? <MarginLeftButton type="primary"
                                                                   onClick={() => this.props.updateConnections(purpose.connections)}>
                            Salva
                        </MarginLeftButton> : ''}
                        {this.canSendToSupplier(purpose) ?
                            <Popconfirm
                                title={<div>
                                    <div>Si è sicuri di voler procedere con l'invio al fornitore?</div>
                                </div>}
                                onConfirm={() => this.sendToSupplier(purpose)}
                                onCancel={() => {
                                }}
                                okText="Conferma" cancelText="Cancella">
                                <MarginLeftButton>
                                    Invia al fornitore
                                </MarginLeftButton>
                            </Popconfirm> : ''}
                        {this.canManageProposal(purpose) ?
                            <MarginLeftButton onClick={() => this.manageProposal(purpose)}>
                                Gestione proposta
                            </MarginLeftButton> : ''}

                        {user.type === userType.SC.key &&
                        <ExcelComponent
                            connections={this.props.proposals[0].connections}/>}

                        {purpose.state === purposeState[3].key && user.type === userType.SC.key &&
                        <MarginLeftButton onClick={() => this.setState({isModalShipmentOpen: true})}>
                            Inserimento dati logistici
                        </MarginLeftButton>}
                        {purpose.state === purposeState[3].key && user.type === userType.SC.key && this.canShipProducts(purpose) &&
                        <Popconfirm
                            title={<div>
                                <div>Si è sicuri di voler procedere con l'operazione?</div>
                            </div>}
                            onConfirm={() => this.onProposalUpdate({state: purposeState[4].key}, purpose.id, true)}
                            onCancel={() => {
                            }}
                            okText="Conferma" cancelText="Cancella">
                            <MarginLeftButton>
                                Conferma invio merce
                            </MarginLeftButton>
                        </Popconfirm>}
                        {purpose.state === purposeState[3].key && user.type === userType.SC.key && !this.canShipProducts(purpose) &&
                        <Tooltip title="Per inviare la merce devi inserire i dati di logistica">
                            <MarginLeftButton disabled={true}>
                                Conferma invio merce
                            </MarginLeftButton>
                        </Tooltip>}
                        {purpose.state === purposeState[4].key && user.type === userType.S.key ?
                            <Popconfirm
                                title={<div>
                                    <div>Si è sicuri di voler procedere con l'operazione?</div>
                                </div>}
                                onConfirm={() => this.onProposalUpdate({state: purposeState[5].key}, purpose.id, true)}
                                onCancel={() => {
                                }}
                                okText="Conferma" cancelText="Cancella">
                                <MarginLeftButton>
                                    Conferma ricevimento merce
                                </MarginLeftButton>
                            </Popconfirm> : ''}
                    </div>
                    <HandleProposalModal
                        user={this.props.user}
                        obj={purpose}
                        visible={this.state.isModalOpen}
                        onOkCallback={this.handleProposal}
                        onCancelCallback={this.closeModal}
                    />
                    <HandleProposalShipmentModal
                        user={this.props.user}
                        obj={purpose}
                        visible={this.state.isModalShipmentOpen}
                        onOkCallback={(changes) => {
                            this.onProposalUpdate({...changes}, purpose.id, true);
                            this.setState({isModalShipmentOpen: false})
                        }}
                        onCancelCallback={this.closeModalShipment}
                    />
                </React.Fragment>
            )
        }
    }

    canSave(proposal) {
        const {user} = this.props;
        return (userType.AM.key === user.type && purposeState[0].key === proposal.state)
            || (userType.S.key === user.type && purposeState[1].key === proposal.state)
            || (userType.SC.key === user.type && purposeState[3].key === proposal.state)
            || (userType.S.key === user.type && purposeState[4].key === proposal.state);
    }

    canSendToSupplier(proposal) {
        return (userType.AM.key === _.get(this.props, ['user', 'type'], null)
            && purposeState[0].key === proposal.state);
    }

    canManageProposal(proposal) {
        const currentUserType = _.get(this.props, ['user', 'type'], null);

        return (userType.S.key === currentUserType && purposeState[1].key === proposal.state)
            || (userType.AM.key === currentUserType && purposeState[2].key === proposal.state);
    }

    sendToSupplier(proposal) {
        this.setState({loading: true});
        this.onProposalUpdate({state: purposeState[1].key}, proposal.id, true);
    }

    openModal = () => this.setState({isModalOpen: true})

    closeModal = () => this.setState({isModalOpen: false})

    closeModalShipment = () => this.setState({isModalShipmentOpen: false})

    handleProposal = (value, proposal) => {
        const ctype = _.get(this.props, ['user', 'type'], null);
        const pstate = _.get(proposal, 'state', null);

        if (value === 'REFUSE' && ctype === userType.S.key && pstate === purposeState[1].key) {
            this.onProposalUpdate({state: purposeState[6].key}, proposal.id, true);
        } else if (value === 'REFUSE' && ctype === userType.AM.key && pstate === purposeState[2].key) {
            this.onProposalUpdate({state: purposeState[7].key}, proposal.id, true);
        } else if (ctype === userType.S.key && pstate === purposeState[1].key) {
            const trash = value === 'ACCEPT_TRASH';
            this.onProposalUpdate({state: purposeState[2].key, trash: trash}, proposal.id, true);
        } else if (ctype === userType.AM.key && pstate === purposeState[2].key) {
            this.onProposalUpdate({state: purposeState[3].key}, proposal.id, true);
        } else if (ctype === userType.SC.key && pstate === purposeState[3].key) {
            this.onProposalUpdate({state: purposeState[4].key}, proposal.id, true);
        } else if (ctype === userType.S.key && pstate === purposeState[4].key) {
            this.onProposalUpdate({state: purposeState[5].key}, proposal.id, true);
        }

        this.setState({
            isModalOpen: false,
            modalObj: null
        });

    }

    manageProposal(proposal) {
        this.setState({
            isModalOpen: true,
            modalObj: proposal
        });
    }

    findStateDescription(state) {
        for (let key in purposeState) {
            if (!purposeState.hasOwnProperty(key)) {
                continue;
            }

            if (state === purposeState[key].key) {
                return purposeState[key].label;
            }
        }

        return null;
    }

    //TODO: canSeeAccordion has to be removed. The correct check will be on proposalArray.length
    render() {
        let proposals = []

        this.props.proposals.forEach((el, i) => {
            proposals.push(
                <Panel header={el.storeId + ' - ' + el.storeName + ' - ' + this.findStateDescription(el.state)} key={i}>
                    {this.renderPurposeTable(el)}
                </Panel>
            )
        });
        //const canSeeAccordion = (this.props.user.type === userType.PM.key) || (this.props.user.type === userType.S.key) || (this.props.user.type === userType.FIN.key)
        return (
            <React.Fragment>
                <h2 style={{marginTop: 24}}>Proposte</h2>
                {proposals && proposals.length > 0 &&
                <Collapse>
                    {proposals}
                </Collapse>}

                {proposals && proposals.length === 0 && <h4>Nessuna proposta è stata lavorata dai capi settore</h4>}

            </React.Fragment>
        )
    }
}

export default Purpose



// WEBPACK FOOTER //
// ./src/components/Purpose/index.js